/**
 * 判断密码是否合法
 * 规则：
 * 1. 长度至少8位
 * 2. 必须包含字母、数字、特殊符号中的至少两种
 * 
 * @param {string} password - 待验证的密码
 * @returns {boolean} - 合法返回 true，否则返回 false
 */
function isPasswordValid(password) {
  // 1. 基础非空及类型检查
  if (!password || typeof password !== 'string') {
    return false;
  }

  // 2. 长度检查：至少8位
  if (password.length < 8) {
    return false;
  }

  // 3. 定义三种字符类型的存在性检测
  const hasLetter = /[a-zA-Z]/.test(password);
  const hasNumber = /\d/.test(password);
  // 特殊符号定义为：非字母且非数字的字符
  const hasSpecial = /[^a-zA-Z0-9]/.test(password);

  // 4. 计算满足的条件数量
  let count = 0;
  if (hasLetter) count++;
  if (hasNumber) count++;
  if (hasSpecial) count++;

  // 5. 返回结果：至少满足其中两种
  return count >= 2;
}

export default isPasswordValid;
